document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".Banner_Slider");
  const prevArrow = slider.parentElement.querySelector(".prev");
  const nextArrow = slider.parentElement.querySelector(".next");
  const swiper = new Swiper(".Banner_Slider", {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    direction: "horizontal",
    grabCursor: true,
    speed: 1000,
    parallax: true,
    navigation: {
      nextEl: nextArrow,
      prevEl: prevArrow,
    },
    // autoplay: {
    //   delay: 4000,
    //   disableOnInteraction: false,
    // },
  });
});
{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".Collections_slide");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "horizontal",
          // loop: true,
          speed: 1000,
          //   autoplay: {
          //     delay: 1000,
          //     disableOnInteraction: false,
          //   },
          grabCursor: true,
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          breakpoints: {
            150: {
              slidesPerView: 1.5,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 2.5,
              spaceBetween: 10,
            },
            769: {
              slidesPerView: 2.6,
              spaceBetween: 10,
            },
            1025: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".Products__lists");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "horizontal",
          // loop: true,
          speed: 1000,
          //   autoplay: {
          //     delay: 1000,
          //     disableOnInteraction: false,
          //   },
          grabCursor: true,
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          breakpoints: {
            150: {
              slidesPerView: 1.5,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 2.5,
              spaceBetween: 10,
            },
            769: {
              slidesPerView: 3,
              spaceBetween: 10,
            },
            1025: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
            1600: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".vernt_Slide");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "horizontal",
          // loop: true,
          speed: 1000,
          //   autoplay: {
          //     delay: 1000,
          //     disableOnInteraction: false,
          //   },  slidesPerView: 1,
          spaceBetween: 10,
          grabCursor: true,
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
        });
      });
    };
    MultipleSlider();
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".Video_Center_slider").forEach((slider) => {
      const wrapper = slider.querySelector(".swiper-wrapper");
      const originalSlides = slider.querySelectorAll(".swiper-slide");
      const prevArrow = slider.parentElement.querySelector(".prev");
      const nextArrow = slider.parentElement.querySelector(".next");
      // const clones = parseInt(slider.dataset.cloneMultiplier, 10) || 2;
      // for (let i = 0; i < clones; i++) {
      //   originalSlides.forEach((s) => wrapper.appendChild(s.cloneNode(true)));
      // }

      const swiper = new Swiper(slider, {
        loop: true,
        centeredSlides: true,
        speed: 1000,
        navigation: {
          nextEl: nextArrow,
          prevEl: prevArrow,
        },
        breakpoints: {
          1025: {
            spaceBetween: 20,
            slidesPerView: 3,
          },
          769: {
            spaceBetween: 20,
            slidesPerView: 2.5,
          },
          576: {
            spaceBetween: 10,
            slidesPerView: 2.2,
          },
          300: {
            spaceBetween: 10,
            slidesPerView: 1.2,
          },
        },
      });
    });
  });
}
